import type { IntentStatus } from "@s2z-platform/types";

type StripeSubscriptionStatus =
  | "active"
  | "canceled"
  | "incomplete"
  | "incomplete_expired"
  | "past_due"
  | "paused"
  | "trialing"
  | "unpaid";

export type SubscriptionState = "active" | "canceled" | "incomplete";

/**
 * @returns "active" sub is still in use, even if it is "past_due" for example.
 * @returns "canceled" sub was one active, but now canceled.
 * @returns "incomplete" sub never finished initial setup.
 */
export function getSubscriptionState(impactIntent: {
  subscriptionStatus: StripeSubscriptionStatus;
  intentStatus: IntentStatus;
}): SubscriptionState {
  const { subscriptionStatus, intentStatus } = impactIntent;
  // Canceled is always canceled
  if (subscriptionStatus === "canceled") return "canceled";

  // Incomplete sub status = never finished initial setup
  if (
    subscriptionStatus === "incomplete" ||
    subscriptionStatus === "incomplete_expired"
  )
    return "incomplete";

  // Legacy edge case: sub is "active" but initial payment was never completed
  // (from before payment_behavior: 'default_incomplete' was set)
  if (
    subscriptionStatus === "active" &&
    (intentStatus === "requires_payment_method" ||
      intentStatus === "requires_confirmation")
  ) {
    return "incomplete";
  }

  // active, past_due, trialing, paused — all treated as alive
  return "active";
}

export function isSubscriptionActiveLike(impactIntent: {
  subscriptionStatus: StripeSubscriptionStatus;
  intentStatus: IntentStatus;
}): boolean {
  return getSubscriptionState(impactIntent) === "active";
}
